import React from 'react'
import "./../../AttestationPage/AttestationBloreCert/AttestationBloreCert.css";
import ApostilleBloreCertMain from './ApostilleBloreCertMain';

const ApostilleBloreCert = () => {
  return (
    <div className='atteBloreCertContainer' >
    <ApostilleBloreCertMain/>
  </div>
  )
}

export default ApostilleBloreCert
